import { Capacitor } from "@capacitor/core";

export function publicSiteUrl(): string {
  const configured = import.meta.env.VITE_SITE_URL?.trim().replace(/\/$/u, "");
  if (configured) return configured;
  return window.location.origin;
}

export function publicAppPath(path: string): string {
  const normalized = path.startsWith("/") ? path : `/${path}`;
  return `${publicSiteUrl()}${normalized}`;
}

export function apiUrl(path: string): string {
  if (!Capacitor.isNativePlatform()) return path;
  return publicAppPath(path);
}
